import { useTranslation } from '../../../../components/Translation';
import { collaborators } from '../../../../constants/laboratory/collaborators';

export default function CollaboratorsSection() {
  const { t } = useTranslation();

  return (
    <>
      {/* Collaborators */}
      <section className="py-16 bg-gray-50 border-t border-gray-200">
        <div className="max-w-5xl mx-auto px-6 text-center">
          <h2 className="text-2xl font-bold text-azul-uady mb-2">
            {t('laboratorio.colaboradores')}
          </h2>
          <p className="text-gray-500 text-mini mb-10">
            {t('laboratorio.colab_subtitulo')}
          </p>
          <div className="flex flex-wrap justify-center items-center gap-10">
            {collaborators.map((logo, i) => (
              <div key={i} className="flex flex-col items-center gap-2 opacity-60 hover:opacity-100 transition-opacity">
                <img src={logo.src} alt={logo.alt} className="h-10 object-contain grayscale hover:grayscale-0 transition-all" />
                <p className="text-micro text-gray-400 font-semibold tracking-wider">{t(`logo.${logo.subtitleKey}`)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Banner */}
      <section className="py-20 bg-[#0d1f35] text-center">
        <div className="max-w-2xl mx-auto px-6">
          <h2 className="text-3xl font-bold text-white mb-4">
            {t('laboratorio.colab_cta_titulo')}
          </h2>
          <p className="text-white/60 text-mini mb-8">
            {t('laboratorio.colab_cta_desc')}
          </p>
          <a
            href="/contactUs"
            className="inline-block bg-dorado-uady text-white font-semibold text-mini px-8 py-3 rounded hover:bg-yellow-600 transition-colors"
          >
            {t('laboratorio.colab_cta_btn')}
          </a>
        </div>
      </section>
    </>
  );
}